<template>
  <section>
    <div class="fileBoxStep3">
      <div class="fileBoxStep3-title">
        {{ obj.title }}
      </div>
      <div class="fileBoxStep3-date">
        2019-10-29 来源：河南省教育厅
      </div>
      <div class="fileBoxStep3-content">
        <div
          v-for="(item, index) in obj.content"
          :key="index"
          :style="{
            fontWeight: item.type == 'title' ? 'bold' : 'normal',
            textIndent: item.indent,
          }"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ComStep3',
  components: {},
  props: {
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang='scss' scoped>
.fileBoxStep3 {
  height: 100%;
  padding: 20px;
  &-title {
    height: 60px;
    font-size: 26px;
    text-align: center;
    margin-top: 20px;
    color: #333;
    font-weight: bold;
    font-family: "Microsoft YaHei";
  }
  &-date {
    text-align: center;
    color: #999;
    font-size: 14px;
    padding-bottom: 20px;
    font-family: "Microsoft YaHei";
  }
  &-content {
    line-height: 36px;
    @include fun-design(1);
    color: #333;
    font-size: 16px;
    font-family: "Microsoft YaHei";
  }
}
</style>
